<script setup lang="ts">
  import AuthProvider from "./AuthProvider.vue";
  import MessageProvider from "./MessageProvider.vue";
  import NotificationProvider from "./NotificationProvider.vue";
  import PwaProvider from "./PwaProvider.vue";
</script>

<template>
  <AuthProvider>
    <MessageProvider>
      <NotificationProvider>
        <PwaProvider>
          <slot></slot>
        </PwaProvider>
      </NotificationProvider>
    </MessageProvider>
  </AuthProvider>
</template>

<style lang="scss" module></style>
